<template>
  <div>
    <el-drawer
      :title="scope.subject"
      :visible.sync="isShowMore"
      @close="close"
      direction="rtl"
      size="50%"
    >
      <div
        v-html="scope.context"
        style="margin-left: 60px; font-size: 14px"
      ></div>
    </el-drawer>
  </div>
</template>
<script>
/**
 * 右侧抽屉组件
 * 功能：用 v-html 渲染富文本内容（如邮件正文展开）
 */
export default {
  name: "Spread",
  data() {
    return {
      isShowMore: false,
    };
  },
  props: {
    scope: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  created() {
    this.openInfo();
  },
  methods: {
    /** 打开抽屉展示内容 */
    openInfo() {
      this.isShowMore = true;
    },
    /** 关闭抽屉并通知父组件 */
    close() {
      this.$emit("isShowEdit");
    },
  },
};
</script>
<style scoped>
p {
  word-wrap: break-word !important;
}
.el-drawer__header {
  font-size: 16px !important;
}
</style>

